/**
 * Date Formatting Utility for Tripura Darpan
 * Converts ISO format (YYYY-MM-DD) to DD-MM-YYYY format
 */

/**
 * Format date from YYYY-MM-DD to DD-MM-YYYY
 * @param {string} dateString - Date in YYYY-MM-DD format or ISO string
 * @returns {string} - Date in DD-MM-YYYY format (e.g., "28-07-2026")
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    // Handle both YYYY-MM-DD and full ISO timestamp formats
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original if invalid
    }
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString; // Return original on error
  }
};

/**
 * Format date with fallback for created_at
 * @param {string} date - Primary date field
 * @param {string} createdAt - Fallback created_at timestamp
 * @returns {string} - Formatted date in DD-MM-YYYY
 */
export const formatDateWithFallback = (date, createdAt) => {
  const dateToFormat = date || createdAt;
  return formatDate(dateToFormat);
};
